import type { AuthState, PrincipalDto } from "@/shared/types/state-manager/auth";
import { UserType } from "@/shared/types/state-manager/auth";

export interface IAuthState extends AuthState {}
export interface IPrincipalDto extends PrincipalDto {}
export const IUserType = UserType;
